import { render, staticRenderFns } from "./CommentPopover.vue?vue&type=template&id=d753bd38&"
import script from "./CommentPopover.vue?vue&type=script&lang=js&"
export * from "./CommentPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports